import { Base } from "./model/core/base.model";

export class ProductosSalidaBean extends Base{
    id: number; 
    id_cu: number;
    descripcion: string;
    producto_salida_anterior: string;
}


